import React from "react"
import { Link } from 'gatsby'
import styled from "@emotion/styled"
import { renderEmoji } from '../../helpers/emoji.js'

export default class ShortDescriptionRow extends React.PureComponent {
  constructor(props) {
    super(props);
		this.state = { show_variants: false };
  }
  toggleVariant = () => {
    this.setState({"show_variants":!this.state.show_variants})
  }
  getName = () => {
    const {parentName, name} = this.props.emoji;
    return parentName || name;
  }
  getVariantCount = () => {
    const {variants, genderVariants} = this.props.emoji;
    return variants.length + genderVariants.reduce((accumulator, currentValue) => {
      return accumulator + 1 + currentValue.variants.length
    }, 0);
  }
  getRenderedEmojis = () => {
    const { siblings, codepoints } = this.props.emoji;
    let str = renderEmoji(codepoints);
    for (var i = 0; i < siblings.length; i++) {
      str += ` ${renderEmoji(siblings[i].codepoints)}`;
    }
    return str;
  }
  getTopLevelGenderEmojis = () => {
    let str = '';
    const emoji = this.props.emoji;
    if (emoji.showGenderVariantsAtTopLevel) {
      str = renderEmoji(this.props.emoji.codepoints);  
      const gender_variants = this.props.emoji.genderVariants;
      for (var i = 0; i < gender_variants.length; i++) {
        str += ` ${renderEmoji(gender_variants[i].codepoints)}`;
      }
    }
    return str;
  }
  render() {
    const {emoji, parentKey} = this.props;
    const {siblings, variants, genderVariants} = emoji;
    const name = this.getName();
    const rendered_emojis = this.getRenderedEmojis();
    const top_level_gender_emojis = this.getTopLevelGenderEmojis();
    const variant_count = this.getVariantCount();
    return <ShortDescriptionStyle 
      className={`${variant_count ? 'hasVariants' : ''} ${this.state.show_variants ? 'showVariants' : ''}`}>
      <div className="emojiContainer">
        <div className="emojiNameInfo">
          { siblings.length > 2 && <span className="emojiName">
          <Link to={`/${emoji.path}/`}>{name}</Link>
          </span> }
          {` `}
          <span className={`emojiChar${siblings.length <= 2 ? ' single' : ''}`}>
            {top_level_gender_emojis || rendered_emojis}
          </span>{` `}
          { siblings.length <= 2 && <span className="emojiName">
            <Link to={`/${emoji.path}/`}>{name}</Link>
          </span> }
          { variant_count > 0 && <div 
            className="variantCount" 
            onClick={this.toggleVariant}
            onKeyPress={this.toggleVariant}
            tabIndex={0} 
            role={`button`}
            aria-expanded={this.state.show_variants ? "true" : "false"}
            aria-controls={`${parentKey}-variants`}
            >
              +{variant_count} variants
            </div>
          }
        </div>
        <div id={`${parentKey}-variants`} className="emoji_description">{this.props.emoji.shortDescription}</div>
        {(variants.length > 0 || genderVariants.length > 0) &&
          <div className={`variants ${this.state.show_variants ? 'show' : ''}`} >
            <ul>
              {
                top_level_gender_emojis && <li>
                  <span className="variantChar">
                    {rendered_emojis}
                  </span>{` `}
                  {this.props.emoji.name}
                  <ul>
                    { variants.map((variant, vi) => {
                      return <li key={variant.id}>
                        <span className="variantChar">
                          {renderEmoji(variant.codepoints)}
                          {siblings.map((s) => {
                            return `${renderEmoji(s.emoji_variants[vi].codepoints)}`
                          })}
                        </span>{` `}
                        {variant.name.replace(`${this.props.emoji.name}: `, '')}
                      </li>
                    })}
                  </ul>
                </li>
              }
              { !top_level_gender_emojis && variants.map((variant, vi) => {
                return <li key={vi}>
                  <span className="variantChar">
                    {renderEmoji(variant.codepoints)}
                    {siblings.map((s) => {
                      return `${renderEmoji(s.variants[vi].codepoints)}`
                    })}
                  </span>{` `}
                  {variant.name.replace(`${this.props.emoji.name}: `, '')}
                </li>
              })}
            </ul>
            <ul>
              {genderVariants.map((variant) => {
                  return <li className="genderChar" key={variant.id}>
                    <span className="variantChar">{renderEmoji(variant.codepoints)}</span>{` `}
                    {variant.name}
                  <ul>
                    {variant.variants.map((variant2) => {
                      return <li key={variant2.id}>
                      <span className="variantChar">{renderEmoji(variant2.codepoints)}</span>{` `}
                      {variant2.name.replace(`${variant.name}: `, '')}
                      </li>
                    })}
                  </ul>
                </li>
              })}
            </ul>
          </div>  
        }
      </div>
    </ShortDescriptionStyle>
  }
}

const ShortDescriptionStyle = styled("li")`
width: 100%;
float: left;
clear: left;
border-bottom: 1px solid #444;
margin: 0 0 .5em;
padding: 0 0 .5em;

.variants {
  display: none;
}
.variants > ul {
  padding-left: 34px;
}
.variants > ul > li > ul {
  padding-left: 20px;
}

.emojiChar {
  font-family: auto; font-size: 22px; min-width: 22px; line-height: 30px; min-height: 30px; margin-right: 0.2em 
}
.single {
  float: left;
}
.emojiName {float: left; height: 30px; line-height: 24px; margin-right: 0.2em;}
.variantChar {font-size: 18px; min-width: 18px; margin-right:2px; }
.variantCount {color:#555; font-size:12px; cursor: pointer; white-space: nowrap; float: left; height: 30px; line-height: 24px; margin-right: 0.2em; }  

.emojiNameInfo {float: left; width: 30%; }
.emoji_description {float: right; line-height: 24px; width: 70%; color: #333; }

.variantCount:hover {text-decoration: underline}

&.showVariants {
  .emojiContainer {
    background: white;  
  }
  .variants.show {
    display: block !important;
  }
}
`